<template>
    <div class="card">
        <div class="card-body">
            <h4 class="header-title mt-0">{{titles.updatePassword}}</h4>
            <form @keyup.enter="onSubmit" class="text-left">
                <h3 class="text-center text-danger mb-3" v-if="errorMsg">{{ errorMsg }}</h3>
                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <Input :icon="icons.password"
                                   :inputKey="'oldpassword'"
                                   :name="titles.oldpassword"
                                   :type="'password'"
                                   :validate="$v.formComponent.oldpassword"
                                   @method="getValue"
                            />
                            <div :class="{ 'invalid-feedback-erreur':  verifpassword}"
                                 class="invalid-feedback">
                                {{titles.passwordInvalid}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <Input :icon="icons.password"
                                   :inputKey="'newPassword'"
                                   :name="titles.newpassword"
                                   :type="'password'"
                                   :validate="$v.formComponent.newPassword"
                                   @method="getValue"/>
                        </div>
                        <div class="col-lg-6">
                            <Input :icon="icons.password"
                                   :inputKey="'newRetypedPassword'"
                                   :name="titles.newRetypedPassword"
                                   :type="'password'"
                                   :validate="$v.formComponent.newRetypedPassword"
                                   @method="getValue"/>
                        </div>
                    </div>
                </div>
                <div class="px-4 text-right">
                    <button
                            :disabled="isLoading || verifpassword"
                            @click="onSubmit"
                            class="btn btn-standard-gradient px-5"
                            type="button">
                        <b-spinner label="Spinning" small v-if="isLoading"></b-spinner>
                        {{name_btn}}
                    </button>
                    <modal-success
                            :title="titles.successProfilMessage"
                            @messageFromModal="closeModal"
                            id="success-profile"
                    />
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import {
        helpers,
        minLength,
        required,
        sameAs
    } from 'vuelidate/lib/validators';
    import ModalSuccess from '@/components/common/modal-success';
    import {titles} from '../../../utils/general/titles.js';
    import {icons} from '../../../utils/general/icons';
    import Input from '@/components/common/Input.vue';
    import {
        getVerifPassword,
        updateClient
    } from '../../shared/services/user.service';
    import {errorMixin} from '../../../utils/errorMixin';

    const mustBeValidPassword = helpers.regex(
        'alpha',
        /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])/
    );
    export default {
        name: 'commercial-form',
        components: {Input, ModalSuccess},
        props: {
            form: Object
        },
        data() {
            return {
                titles,
                icons,
                isLoading: false,
                errorMsg: '',
                name_btn: titles.update,
                title: titles.profileUpdateExpression,
                formComponent: this.form,
                verifpassword: false
            };
        },
        validations: {
            formComponent: {
                oldpassword: {required, mustBeValidPassword, minLength: minLength(6)},
                newPassword: {required, mustBeValidPassword, minLength: minLength(6)},
                newRetypedPassword: {required, sameAsPassword: sameAs('newPassword')}
            }
        },
        mixins: [errorMixin],
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                updateClient(this.formComponent, this.$store.getters.user.id).then(
                    response => {
                        this.$cookies.set('token', {
                            token: response.data.token,
                            refresh_token: response.data.refresh_token
                        });
                        this.$bvModal.show('success-profile');
                        return response;
                    },
                    error => {
                        this.showError(error);
                    }
                );
                this.isLoading = true;
            },
            getValue(inputKey, val) {
                this.$v.formComponent[inputKey].$touch();
                this.formComponent[inputKey] = val;
                if (inputKey == 'oldpassword') {
                    this.verifpassword = false;
                    getVerifPassword(this.$cookies.get('user').email, this.formComponent.oldpassword).then(
                        response => {
                            if (response.data == 'Error') {
                                this.verifpassword = true;
                                return false;
                            } else {
                                return response;
                            }
                        });
                }
            },
            closeModal() {
                this.$router.push({name: '/'});
            }
        }
    };
</script>
<style scoped>
</style>
